<template>
  <v-app>
    <router-view></router-view>
    <v-dialog v-model="errordialog" persistent width="500">
      <v-card class="pa-4">
        <v-card-title class="headline">Message<v-icon large class="ml-3"
            color="red">mdi-alert-circle</v-icon></v-card-title>
        <v-card-text>
          <p v-html="errormessage"></p>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn tile @click="clearerror()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog ref="confirm"></ConfirmDialog>
  </v-app>
</template>

<script>

import { HTTP } from '@/plugins/backendAPI'
import { mapGetters } from 'vuex'
import ConfirmDialog from '@/components/ConfirmDialog'
import { logout } from './helpers/logoutHandler';

export default {
  name: 'App',

  components: { ConfirmDialog },
  data() {
    return {
    }
  },
  mounted() {
    this.$root.$ConfirmDialog = this.$refs.confirm
  },
  async created() {
      await this.$store.state.msalInstance.initialize()
      this.getUser()
    this.$store.dispatch('initStorage')
  },
  computed: {
    ...mapGetters([
      'errordialog',
      'errormessage',
      'isauthorized',
      'bearertoken',
      'workspaceid',
      'loading'
    ])
  },
  methods: {
    async getUser() {
      try {
        // Rehydrate token from localStorage if needed
        const token = this.bearertoken || localStorage.getItem('authToken');
        if (!token) {
          console.warn('No token found, user might not be logged in.');
          return;
        }

        HTTP.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        this.$store.dispatch('setLoading', true);

        const response = await HTTP.get("/users/get/logged-in-user");

        this.$store.dispatch('saveAuthorization', {
          username: response.data.email,
          isauthorized: true,
          bearertoken: token,
          isadministrator: response.data.isAdministrator,
          issuperadministrator: response.data.isSuperAdministrator,
          isOwner: response.data.role === 1,
          hasWorkspaceAuthorization: response.data.hasWorkspaceAuthorization,
          userAuthProvider: response.data.authProvider,
        });

      } catch (error) {
        console.error('Failed to fetch user:', error);
        if (this.isauthorized) {
          await logout();
        }
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    clearerror() {
      this.$store.dispatch('clearError')
    },
  }
}
</script>
